// extracted by mini-css-extract-plugin
module.exports = {"widgetCalories":"WidgetCalories_widgetCalories__11HU7","actionsBar":"WidgetCalories_actionsBar__2ZGdI"};